import mock from './mock'

import './apps/invoice'
import './apps/clientList'
import './apps/serviceList'
import './apps/taskList'
import './apps/dscList'
import './navbar/navbarSearch'
import './apps/application'
import './apps/FileManager'

mock.onAny().passThrough()
